export default {
      id: "ic-soc-x-usage",
      viewBox: "0 0 26 26",
      url: "../dist/images/" + "sprite.svg#ic-soc-x-usage",
      toString: function () {
        return this.url;
      }
    }